// TODO: move models here
// TODO: also consider having a separate dictionary file for analyst suggestions in the cmd palette
// TODO: this should also be done for other agents
export enum DataModelItemStatus {
  CREATED = 'created',
  MAPPED = 'mapped',
  // Item resolved to a PROJECT/LIBRARY data-type entry; applied as an OBJECT reference attribute.
  REFERENCED = 'referenced',
}

export const UI_GENERATION_HINT_MESSAGE = 'I am here to support you in generating UI in this area.'
export const UI_FLOW_ELEMENT_SUBJECT = 'UI flow element'
export const UI_FLOW_TARGET_DELETED_MESSAGE =
  'The target of the pending UI generation was deleted. The generated draft was discarded.'
export const RELOAD_UI_FLOW_FAILURE_MESSAGE = 'Failed to reload UI Flow'
export const RELOAD_FAILURE_STATUS_CODE = 0
